<template>
  <form-select
    class="product-select"
    v-model="val"
    :options="options"
    @change="change"
    v-on="$listeners"
  ></form-select>
</template>
<script>
export default {
  name: 'product-select',
  props: {
    category: String,
    subcategory: String,
    value: String,
    region: String,
    lang: String,
    profile: String
  },
  model: {
    prop: 'value',
    event: 'setval'
  },
  computed: {
    val: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('setval', newVal)
      }
    }
  },
  data() {
    return {
      options: []
    }
  },
  created() {
    this.getProduct()
  },
  methods: {
    getProduct() {
      this.options = []
      this.val = null
      this.$post('view/getProduct', {
        category: this.category,
        lang: this.lang,
        region: this.region
      })
        .then((resp) => {
          if (resp.data.code == 0 && resp.data.data.length > 0) {
            var options = []
            for (var item of resp.data.data) {
              options.push(
                Object.assign({ label: item.name, value: item.profile }, item)
              )
            }
            this.options = options
            // 默认选中第一项，如果是从产品详情页跳转值功能表页面，则根据packid,version匹配默认选中项
            let currentProduct = this.profile
              ? options.find((f) => f.profile === this.profile)
              : options[0]
            if (currentProduct) {
              this.val = currentProduct.value
              this.$nextTick(() => {
                this.$emit('productChange', currentProduct)
              })
            }
          } else {
            this.$message('获取产品失败')
          }
        })
        .catch((error) => {
          this.$message('获取产品发生错误=>' + error)
        })
    },
    change(val) {
      for (var item of this.options) {
        if (item.value == val) {
          this.$emit('productChange', item)
          return
        }
      }
    }
  },
  watch: {
    category(newVal) {
      newVal && this.getProduct()
    }
  }
}
</script>
<style lang="less">
.product-select {
  width: 100px;
}
</style>
